import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <>
      {/* Nueva sección del header en negro */}
      <div className="header-black">
        <div className="header-content">
          <div className="header-text">
            <h1 >CENTRO DE 
             <span className="highlight-header"> ÉXITO EN VENTAS</span>
               </h1>
            <p>DE APRENDIZ A EXPERTO EN TAN SOLO 60 DÍAS, CONQUISTA EL MUNDO DE LAS VENTAS Y TE ENSEÑAMOS DÓNDE ENCONTRAR OPORTUNIDADES</p>
          </div>
          <div className="header-logo">
            <img src="/Images/logo_sinback.png" alt="Closer Academy Logo" />
          </div>
        </div>
        <button className="platform-button" onClick={() => window.location.href = 'https://streaming.closeracademy.app/'}>
          INICIA SESIÓN COMO ALUMNO
        </button>
      </div>

      {/* Sección original del header */}
      <header className="header">
        <h2>¿PORQUÉ EMPEZAR?</h2>
      </header>
    </>
  );
};

export default Header;
